export default "__VITE_ASSET__DTRSJhHx__"